import { Logger } from '@nextgen-web-framework/core';
import { logObject } from '@commerce-product-webcomponents/sdk';
import { LinkQueryParamsEnum } from './common';

const loggerInstance = Logger.getInstance(logObject('dynamicUrlGeneratorError'));
// Utility to generate a URL with dynamic query parameters
const buildUrlWithQueryParams = (baseUrl: string, queryParams?: Record<string, string>) => {
  try {
    if (queryParams) {
      const queryString = Object.entries(queryParams)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');

      const separator = baseUrl.includes('?') ? '&' : '?';
      return baseUrl + separator + queryString;
    }
    return baseUrl;
  } catch (error) {
    loggerInstance.error('Error in dynamic URL generator: ', error);
    return baseUrl;
  }
};

export const createDynamicUrl = (
  baseUrl: string,
  allowedParams?: string[], // List of query parameters allowed for the URL
  language?: string,
  aboNumber?: string,
): string => {
  const dynamicParams: Record<string, string> = {};
  const locale = language;
  // Add 'abo' parameter if allowed and accountNumber exists
  if (allowedParams?.includes(LinkQueryParamsEnum.abo) && aboNumber) {
    dynamicParams['abo_id'] = aboNumber;
  }

  // Add 'lang' parameter if allowed and locale exists
  if (allowedParams?.includes(LinkQueryParamsEnum.lang) && locale) {
    dynamicParams['lang'] = locale;
  }
  // We can add more parameter in future if required
  return buildUrlWithQueryParams(baseUrl, dynamicParams);
};
